import { FAQSkeleton } from "./states/FAQSkeleton";
import { FAQAccordion } from "./components/FAQAccordion";

interface FAQSectionProps {
  isLoading: boolean;
}

export function FAQSection({ isLoading }: FAQSectionProps) {
  if (isLoading) return <FAQSkeleton />;
  return <FAQAccordion />;
}
